<template>
  <div class="Home">
    <header class="masthead d-flex">
      <div class="container text-center my-auto">
        <a href="http://eaglescan.ng" rel="noreferrer">
          <img :src="client.logo" alt class="logo" />
        </a>
        <h1 class="mb-1"><!-- {{ client.name }} --></h1>
        <h3 class="mb-5 font-weight-bold">Support Ticketing Platform</h3>
        <h3 class="mb-5">
          <em>
            For your complaints, issues, enquiries. Our team
            <br />can monitor and effectively treat your complaint.
          </em>
        </h3>
        <router-link class="btn btn-primary btn-xl js-scroll-trigger" to="/create">Create Support Ticket</router-link>
        <router-link class="btn btn-secondary btn-xl ml-4 js-scroll-trigger" to="/my-tickets">Access Existing Ticket</router-link>
        <p class="mt-5">
          <router-link to="/login">Login</router-link>
        </p>
      </div>
      <div class="overlay"></div>
    </header>
    <!--  <div class="row">
      <div class="col-12">
        <h1>dfsdfdfds</h1>
      </div>
    </div>-->
    <!-- <Chat /> -->
  </div>
</template>

<script>
//import axios from "axios";
//import brand from "../helper/brand";
//import Chat from "../components/Chat";

export default {
  name: "Home",

  components: {
    //Chat,
  },

  mounted() {
    this.$store.dispatch("getClient");
    /*
    let btnPrimary = document.querySelectorAll(".btn-primary");
    for (let index = 0; index < btnPrimary.length; index++) {
      btnPrimary[index].style.backgroundColor = this.client.color;
      btnPrimary[index].style.borderColor = this.client.color;
    }
    */
  },

  computed: {
    client() {
      return this.$store.state.client;
    },
  },

  /* updated() {
    brand.primaryBtn(this.client.color, this.client.color2);
  } */
};
</script>


<style scoped>
body,
html {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  color: #212529;
  text-align: left !important;
  background-color: #fff !important;
}

.masthead {
  height: 100vh !important;
}

.masthead {
  min-height: 30rem;
  position: relative;
  display: table;
  width: 100%;
  height: auto;
  padding-top: 8rem;
  padding-bottom: 8rem;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0, rgba(255, 255, 255, 0.1) 100%), url(/img/bg-masthead.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.d-flex {
  display: -ms-flexbox !important;
  display: flex !important;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.text-center {
  text-align: center !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}
.masthead h1 {
  font-size: 3.8rem;
  margin: 0;
  padding: 0;
  font-weight: 600;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}
.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.btn-xl {
  padding: 1.25rem 2.5rem !important;
  font-weight: 600 !important;
  font-size: 1.2rem;
}
.btn-secondary {
  background-color: #9b9a9a;
  border-color: #9b9a9a;
}
.logo {
  width: 350px !important;
  margin-bottom: 15px;
}
@media (min-width: 992px) {
  .masthead h1 {
    font-size: 3.3rem;
  }
}
@media (max-width: 991.98px) {
  .logo {
    width: 160px !important;
    margin-bottom: 15px;
  }
  .masthead h1 {
    font-size: 1.3rem;
    margin: 0;
    padding: 0;
    font-weight: 600;
  }
  .masthead h3 {
    font-size: 0.8rem;
  }

  .btn-xl {
    padding: 0.8rem 1.5rem !important;
    font-weight: 600 !important;
    font-size: 0.8rem;
  }
}
@media (max-width: 575.98px) {
  .logo {
    width: 200px !important;
    margin-bottom: 15px;
  }
  .masthead h1 {
    font-size: 2rem;
    margin: 0;
    padding: 0;
    font-weight: 600;
  }
  .masthead h3 {
    font-size: 1.1rem;
  }
  .btn-secondary {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
  .btn-xl {
    padding: 1rem 2rem !important;
    font-weight: 600 !important;
    font-size: 1rem;
  }
}
</style>